import { render } from "./ZoneProductPricingAddOrUpdateTable.html?vue&type=template&id=17d127a0&scoped=true"
import script from "./ZoneProductPricingAddOrUpdateTable.js?vue&type=script&lang=js"
export * from "./ZoneProductPricingAddOrUpdateTable.js?vue&type=script&lang=js"

import "./ZoneProductPricingAddOrUpdateTable.css?vue&type=style&index=0&id=17d127a0&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d127a0"]])

export default __exports__